import { z } from 'zod';

export const InsertIntegrationSettingsValuesShema = z.array(
  z
    .object({
      integrationSettingsValues: z.any(),
      accountId: z.string().uuid().optional(),
      locationId: z.string().uuid().optional(),
      userProfileId: z.string().uuid().optional(),
      integrationName: z.string().min(1),
      integrationSettingsValuesId: z.string().uuid().nullable(),
    })
    .refine(({ accountId, locationId, userProfileId }) => accountId || locationId || userProfileId, {
      message: 'At least one of accountId, locationId, or userProfileId must be provided and be a valid UUID',
      path: [],
    })
);
